import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false, // Modo claro por defecto
    themes: {
      light: {
        primary: '#1976D2', // Azul predeterminado
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
      },
      dark: {
        primary: '#BB86FC', // Morado predeterminado en oscuro
        secondary: '#03DAC6',
        accent: '#FF4081',
        error: '#CF6679',
        info: '#03A9F4',
        success: '#00E676',
        warning: '#FF9800',
      },
    },
  },
});
